const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Clerko</h3>
            <p className="text-gray-400">
              Impulsamos el crecimiento digital de estudios contables en Argentina.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Diseño web</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Asistente IA</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Hosting</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Capacitación</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Términos</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Privacidad</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">contacto@clerko.online</li>
              <li className="text-gray-400">+54 353 4199577</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Clerko by Hernán Grosso. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;